import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
} from 'firebase/auth';
import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import { ADMIN_SIGNUP_CODE } from '../config/admin';
import { auth, db } from '../lib/firebase';

const ADMINS_COLLECTION = 'admins';

export async function isAdminUser(uid) {
  const snapshot = await getDoc(doc(db, ADMINS_COLLECTION, uid));
  return snapshot.exists();
}

export async function signUpAdmin({ email, password, adminCode }) {
  const trimmedEmail = email.trim();

  if (adminCode.trim() !== ADMIN_SIGNUP_CODE) {
    throw new Error('관리자 코드가 올바르지 않습니다.');
  }

  const credential = await createUserWithEmailAndPassword(auth, trimmedEmail, password);

  try {
    await setDoc(doc(db, ADMINS_COLLECTION, credential.user.uid), {
      email: trimmedEmail,
      role: 'admin',
      createdAt: serverTimestamp(),
    });
  } catch (error) {
    await signOut(auth);
    throw new Error('관리자 등록에 실패했습니다. 잠시 후 다시 시도해 주세요.');
  }

  return credential.user;
}

export async function signInAdmin({ email, password }) {
  const credential = await signInWithEmailAndPassword(auth, email.trim(), password);
  const allowed = await isAdminUser(credential.user.uid);

  if (!allowed) {
    await signOut(auth);
    throw new Error('관리자 권한이 없습니다. 관리자 코드로 회원가입해 주세요.');
  }

  return credential.user;
}

export async function signOutAdmin() {
  await signOut(auth);
}
